export enum CommunicationMethodEnum {
  email = 0,
  phone = 1,
  both = 2,
}
